/// <amd-module name="TFS/Admin/Groups/Pivots/Members/Redux/MembersPivotReducers" />
import produce from "immer";
import { SearchStatus } from "TFS/Admin/Groups/Common/Constants";
import { IMembersPivotState } from "TFS/Admin/Groups/Common/Contracts";
import * as Resources from "TFS/Admin/Groups/Common/Resources";
import { MembersPivotActions, MembersPivotActionTypes } from "TFS/Admin/Groups/Pivots/Members/Redux/MembersPivotActions";
import { MessageCardSeverity } from "VSSUI/MessageCard";

export function membersPivotReducer(state: IMembersPivotState, action: MembersPivotActions): IMembersPivotState {
    return produce(state || {}, (draft) => {
        switch (action.type) {
            case MembersPivotActionTypes.InitView: {
                draft.data = {
                    totalIdentityCount: 0,
                    identities: [],
                    moreData: true
                };
                draft.searchResult = {
                    keyword: "",
                    resultItems: [],
                    status: SearchStatus.None,
                    hasMore: false
                };
                draft.messageCardText = undefined;
                break;
            }

            case MembersPivotActionTypes.InitialMembersLoadSucceeded: {
                var { members, continuationToken } = action.payload;

                draft.data = {
                    totalIdentityCount: members.length,
                    identities: members,
                    moreData: continuationToken && continuationToken.length > 0 ? true : false,
                    continuationToken: action.payload.continuationToken
                };
                draft.initComplete = true;
                draft.loading = false;
                break;
            }

            case MembersPivotActionTypes.MembersLoadFailed: {
                draft.messageCardText = Resources.UsersLoadFailed;
                draft.messageCardSeverity = MessageCardSeverity.Error;
                draft.data.moreData = false;
                draft.initComplete = false;
                draft.loading = false;
                break;
            }

            case MembersPivotActionTypes.FetchMoreMembersSucceeded: {
                var { members, continuationToken } = action.payload;

                draft.data = {
                    totalIdentityCount: draft.data.totalIdentityCount + members.length,
                    identities: draft.data.identities.slice(0, draft.data.identities.length).concat(members),
                    moreData: continuationToken && continuationToken.length > 0 ? true : false,
                    continuationToken: continuationToken
                };
                draft.loading = false;
                draft.initComplete = false;
                break;
            }

            case MembersPivotActionTypes.MemberOperationStatus: {
                var { resultMessage, severity } = action.payload;
                draft.messageCardText = resultMessage;
                draft.messageCardSeverity = severity;
                break;
            }

            case MembersPivotActionTypes.DismissMessageCard: {
                draft.messageCardText = undefined;
                break;
            }

            case MembersPivotActionTypes.SearchMembers: {
                updateSearchStatus(draft, SearchStatus.Searching);
                break;
            }

            case MembersPivotActionTypes.UpdateSearchStatus: {
                updateSearchStatus(draft, action.payload);
                break;
            }

            case MembersPivotActionTypes.UpdateSearchResult: {
                updateSearchResult(draft, action.payload.keyword, action.payload.result, action.payload.hasMore);
                break;
            }

            default:
                return state;
        }
    });
}

function updateSearchStatus(state: IMembersPivotState, searchStatus: SearchStatus) {
    const { searchResult } = state;
    if (!searchResult) {
        return;
    }
    if (searchStatus === SearchStatus.None) {
        searchResult.resultItems = [];
        searchResult.keyword = "";
    }
    searchResult.status = searchStatus;
}

function updateSearchResult(state: IMembersPivotState, keyword: string, results: any[], hasMore: boolean) {
    if (!keyword || !state.searchResult) {
        return;
    }
    state.searchResult = {
        keyword,
        resultItems: results,
        status: SearchStatus.Completed,
        hasMore
    };
}
